import { c as be, g as ge, j as Ee } from "./jsx-runtime.js";
import { c as Ze, a as fa } from "./Transition.js";
import { r as me, b as he, m as i, E as W, F as u, C as S, A as F, h as y, L as _, v as ze, w as ke, z as q, M as Vr, j as U, p as I, o as T, d as qr, t as Ur, N as _e, O as pa } from "./index2.js";
import O, { useState as Gr, useEffect as Ae, useMemo as Wr, forwardRef as ba, useRef as ga, lazy as ma } from "react";
import "./index10.js";
import "./index5.js";
import { v as X, e as ye, l as ee, a as ve } from "./index4.js";
import { j as Ie, O as Re, f as ha } from "./index13.js";
import { c as ya } from "./index8.js";
import { useChatbotContext as va } from "./useChatbotContext.js";
import "react-dom";
import "./index6.js";
import "./kebabCase.js";
import "./index14.js";
import "./ChatbotProvider.js";
var Jr = { exports: {} };
(function(e, o) {
  (function(t, l) {
    e.exports = l(O, me(), he);
  })(be, function(t, l, s) {
    function d(n) {
      return n && typeof n == "object" && "default" in n ? n : { default: n };
    }
    function b(n) {
      if (n && typeof n == "object" && "default" in n)
        return n;
      var r = /* @__PURE__ */ Object.create(null);
      return n && Object.keys(n).forEach(function(a) {
        if (a !== "default") {
          var c = Object.getOwnPropertyDescriptor(n, a);
          Object.defineProperty(r, a, c.get ? c : { enumerable: !0, get: function() {
            return n[a];
          } });
        }
      }), r.default = n, Object.freeze(r);
    }
    var g = b(t), f = d(l);
    function h(n) {
      var r = function(a, c) {
        if (typeof a != "object" || !a)
          return a;
        var w = a[Symbol.toPrimitive];
        if (w !== void 0) {
          var $ = w.call(a, c || "default");
          if (typeof $ != "object")
            return $;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }
        return (c === "string" ? String : Number)(a);
      }(n, "string");
      return typeof r == "symbol" ? r : r + "";
    }
    function p(n, r, a) {
      return (r = h(r)) in n ? Object.defineProperty(n, r, { value: a, enumerable: !0, configurable: !0, writable: !0 }) : n[r] = a, n;
    }
    function m() {
      return m = Object.assign ? Object.assign.bind() : function(n) {
        for (var r = 1; r < arguments.length; r++) {
          var a = arguments[r];
          for (var c in a)
            Object.prototype.hasOwnProperty.call(a, c) && (n[c] = a[c]);
        }
        return n;
      }, m.apply(this, arguments);
    }
    function N(n, r) {
      if (n == null)
        return {};
      var a, c, w = function(P, B) {
        if (P == null)
          return {};
        var j, k, H = {}, A = Object.keys(P);
        for (k = 0; k < A.length; k++)
          j = A[k], B.indexOf(j) >= 0 || (H[j] = P[j]);
        return H;
      }(n, r);
      if (Object.getOwnPropertySymbols) {
        var $ = Object.getOwnPropertySymbols(n);
        for (c = 0; c < $.length; c++)
          a = $[c], r.indexOf(a) >= 0 || Object.prototype.propertyIsEnumerable.call(n, a) && (w[a] = n[a]);
      }
      return w;
    }
    function L(n, r) {
      return r || (r = n.slice(0)), Object.freeze(Object.defineProperties(n, { raw: { value: Object.freeze(r) } }));
    }
    var M, D, R = { small: 14, default: 16, large: 20, xlarge: 24 }, G = ["className", "size", "title", "aria-label", "aria-labelledby", "fill", "role"], E = function(n) {
      var r = n.className, a = n.size, c = a === void 0 ? 16 : a, w = n.title, $ = n["aria-label"], P = n["aria-labelledby"], B = n.fill, j = n.role, k = j === void 0 ? "img" : j, H = N(n, G), A = s.css(M || (M = L([`
        color: `, `;
      `])), B), ae = s.css(D || (D = L([`
        flex-shrink: 0;
      `]))), oe = function(ie, le, V) {
        var J, K = V["aria-label"], Y = V["aria-labelledby"], Q = V.title;
        switch (ie) {
          case "img":
            return K || Y || Q ? p(p(p({}, "aria-labelledby", Y), "aria-label", K), "title", Q) : { "aria-label": (J = le, "".concat(J.replace(/([a-z])([A-Z])/g, "$1 $2"), " Icon")) };
          case "presentation":
            return { "aria-hidden": !0, alt: "" };
        }
      }(k, "ArrowLeft", p(p({ title: w }, "aria-label", $), "aria-labelledby", P));
      return g.createElement("svg", m({ className: s.cx(p({}, A, B != null), ae, r), height: typeof c == "number" ? c : R[c], width: typeof c == "number" ? c : R[c], role: k }, oe, H, { viewBox: "0 0 16 16" }), g.createElement("path", { d: "M13 6.83212L6.05559 6.83212L7.59059 5.29711C7.98112 4.90659 7.98112 4.27342 7.59059 3.8829L7.35168 3.64398C6.96115 3.25346 6.32799 3.25345 5.93746 3.64398L2.55483 7.02661C2.5456 7.03518 2.5365 7.04395 2.52752 7.05292L2.2886 7.29184C1.89808 7.68237 1.89808 8.31553 2.2886 8.70605L5.93975 12.3572C6.33028 12.7477 6.96344 12.7477 7.35397 12.3572L7.59288 12.1183C7.98341 11.7278 7.98341 11.0946 7.59288 10.7041L6.0588 9.17L13 9.17C13.5523 9.17 14 8.72228 14 8.17V7.83212C14 7.27983 13.5523 6.83212 13 6.83212Z", fill: "currentColor" }));
    };
    return E.displayName = "ArrowLeft", E.isGlyph = !0, E.propTypes = { fill: f.default.string, size: f.default.oneOfType([f.default.number, f.default.string]), className: f.default.string }, E;
  });
})(Jr);
var xa = Jr.exports;
const Oa = /* @__PURE__ */ ge(xa);
var Kr = { exports: {} };
(function(e, o) {
  (function(t, l) {
    e.exports = l(O, me(), he);
  })(be, function(t, l, s) {
    function d(n) {
      return n && typeof n == "object" && "default" in n ? n : { default: n };
    }
    function b(n) {
      if (n && typeof n == "object" && "default" in n)
        return n;
      var r = /* @__PURE__ */ Object.create(null);
      return n && Object.keys(n).forEach(function(a) {
        if (a !== "default") {
          var c = Object.getOwnPropertyDescriptor(n, a);
          Object.defineProperty(r, a, c.get ? c : { enumerable: !0, get: function() {
            return n[a];
          } });
        }
      }), r.default = n, Object.freeze(r);
    }
    var g = b(t), f = d(l);
    function h(n) {
      var r = function(a, c) {
        if (typeof a != "object" || !a)
          return a;
        var w = a[Symbol.toPrimitive];
        if (w !== void 0) {
          var $ = w.call(a, c || "default");
          if (typeof $ != "object")
            return $;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }
        return (c === "string" ? String : Number)(a);
      }(n, "string");
      return typeof r == "symbol" ? r : r + "";
    }
    function p(n, r, a) {
      return (r = h(r)) in n ? Object.defineProperty(n, r, { value: a, enumerable: !0, configurable: !0, writable: !0 }) : n[r] = a, n;
    }
    function m() {
      return m = Object.assign ? Object.assign.bind() : function(n) {
        for (var r = 1; r < arguments.length; r++) {
          var a = arguments[r];
          for (var c in a)
            Object.prototype.hasOwnProperty.call(a, c) && (n[c] = a[c]);
        }
        return n;
      }, m.apply(this, arguments);
    }
    function N(n, r) {
      if (n == null)
        return {};
      var a, c, w = function(P, B) {
        if (P == null)
          return {};
        var j, k, H = {}, A = Object.keys(P);
        for (k = 0; k < A.length; k++)
          j = A[k], B.indexOf(j) >= 0 || (H[j] = P[j]);
        return H;
      }(n, r);
      if (Object.getOwnPropertySymbols) {
        var $ = Object.getOwnPropertySymbols(n);
        for (c = 0; c < $.length; c++)
          a = $[c], r.indexOf(a) >= 0 || Object.prototype.propertyIsEnumerable.call(n, a) && (w[a] = n[a]);
      }
      return w;
    }
    function L(n, r) {
      return r || (r = n.slice(0)), Object.freeze(Object.defineProperties(n, { raw: { value: Object.freeze(r) } }));
    }
    var M, D, R = { small: 14, default: 16, large: 20, xlarge: 24 }, G = ["className", "size", "title", "aria-label", "aria-labelledby", "fill", "role"], E = function(n) {
      var r = n.className, a = n.size, c = a === void 0 ? 16 : a, w = n.title, $ = n["aria-label"], P = n["aria-labelledby"], B = n.fill, j = n.role, k = j === void 0 ? "img" : j, H = N(n, G), A = s.css(M || (M = L([`
        color: `, `;
      `])), B), ae = s.css(D || (D = L([`
        flex-shrink: 0;
      `]))), oe = function(ie, le, V) {
        var J, K = V["aria-label"], Y = V["aria-labelledby"], Q = V.title;
        switch (ie) {
          case "img":
            return K || Y || Q ? p(p(p({}, "aria-labelledby", Y), "aria-label", K), "title", Q) : { "aria-label": (J = le, "".concat(J.replace(/([a-z])([A-Z])/g, "$1 $2"), " Icon")) };
          case "presentation":
            return { "aria-hidden": !0, alt: "" };
        }
      }(k, "ArrowRight", p(p({ title: w }, "aria-label", $), "aria-labelledby", P));
      return g.createElement("svg", m({ className: s.cx(p({}, A, B != null), ae, r), height: typeof c == "number" ? c : R[c], width: typeof c == "number" ? c : R[c], role: k }, oe, H, { viewBox: "0 0 16 16" }), g.createElement("path", { d: "M3 6.83212L9.94442 6.83212L8.40941 5.29711C8.01888 4.90659 8.01889 4.27342 8.40941 3.8829L8.64833 3.64398C9.03885 3.25346 9.67201 3.25345 10.0625 3.64398L13.4452 7.02661C13.4544 7.03518 13.4635 7.04395 13.4725 7.05292L13.7114 7.29184C14.1019 7.68237 14.1019 8.31553 13.7114 8.70605L10.0602 12.3572C9.66972 12.7477 9.03656 12.7477 8.64603 12.3572L8.40712 12.1183C8.01659 11.7278 8.01659 11.0946 8.40712 10.7041L9.9412 9.17L3 9.17C2.44771 9.17 2 8.72228 2 8.17L2 7.83212C2 7.27983 2.44772 6.83212 3 6.83212Z", fill: "currentColor" }));
    };
    return E.displayName = "ArrowRight", E.isGlyph = !0, E.propTypes = { fill: f.default.string, size: f.default.oneOfType([f.default.number, f.default.string]), className: f.default.string }, E;
  });
})(Kr);
var wa = Kr.exports;
const $a = /* @__PURE__ */ ge(wa);
var Yr = { exports: {} };
(function(e, o) {
  (function(t, l) {
    e.exports = l(O, me(), he);
  })(be, function(t, l, s) {
    function d(n) {
      return n && typeof n == "object" && "default" in n ? n : { default: n };
    }
    function b(n) {
      if (n && typeof n == "object" && "default" in n)
        return n;
      var r = /* @__PURE__ */ Object.create(null);
      return n && Object.keys(n).forEach(function(a) {
        if (a !== "default") {
          var c = Object.getOwnPropertyDescriptor(n, a);
          Object.defineProperty(r, a, c.get ? c : { enumerable: !0, get: function() {
            return n[a];
          } });
        }
      }), r.default = n, Object.freeze(r);
    }
    var g = b(t), f = d(l);
    function h(n) {
      var r = function(a, c) {
        if (typeof a != "object" || !a)
          return a;
        var w = a[Symbol.toPrimitive];
        if (w !== void 0) {
          var $ = w.call(a, c || "default");
          if (typeof $ != "object")
            return $;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }
        return (c === "string" ? String : Number)(a);
      }(n, "string");
      return typeof r == "symbol" ? r : r + "";
    }
    function p(n, r, a) {
      return (r = h(r)) in n ? Object.defineProperty(n, r, { value: a, enumerable: !0, configurable: !0, writable: !0 }) : n[r] = a, n;
    }
    function m() {
      return m = Object.assign ? Object.assign.bind() : function(n) {
        for (var r = 1; r < arguments.length; r++) {
          var a = arguments[r];
          for (var c in a)
            Object.prototype.hasOwnProperty.call(a, c) && (n[c] = a[c]);
        }
        return n;
      }, m.apply(this, arguments);
    }
    function N(n, r) {
      if (n == null)
        return {};
      var a, c, w = function(P, B) {
        if (P == null)
          return {};
        var j, k, H = {}, A = Object.keys(P);
        for (k = 0; k < A.length; k++)
          j = A[k], B.indexOf(j) >= 0 || (H[j] = P[j]);
        return H;
      }(n, r);
      if (Object.getOwnPropertySymbols) {
        var $ = Object.getOwnPropertySymbols(n);
        for (c = 0; c < $.length; c++)
          a = $[c], r.indexOf(a) >= 0 || Object.prototype.propertyIsEnumerable.call(n, a) && (w[a] = n[a]);
      }
      return w;
    }
    function L(n, r) {
      return r || (r = n.slice(0)), Object.freeze(Object.defineProperties(n, { raw: { value: Object.freeze(r) } }));
    }
    var M, D, R = { small: 14, default: 16, large: 20, xlarge: 24 }, G = ["className", "size", "title", "aria-label", "aria-labelledby", "fill", "role"], E = function(n) {
      var r = n.className, a = n.size, c = a === void 0 ? 16 : a, w = n.title, $ = n["aria-label"], P = n["aria-labelledby"], B = n.fill, j = n.role, k = j === void 0 ? "img" : j, H = N(n, G), A = s.css(M || (M = L([`
        color: `, `;
      `])), B), ae = s.css(D || (D = L([`
        flex-shrink: 0;
      `]))), oe = function(ie, le, V) {
        var J, K = V["aria-label"], Y = V["aria-labelledby"], Q = V.title;
        switch (ie) {
          case "img":
            return K || Y || Q ? p(p(p({}, "aria-labelledby", Y), "aria-label", K), "title", Q) : { "aria-label": (J = le, "".concat(J.replace(/([a-z])([A-Z])/g, "$1 $2"), " Icon")) };
          case "presentation":
            return { "aria-hidden": !0, alt: "" };
        }
      }(k, "OpenNewTab", p(p({ title: w }, "aria-label", $), "aria-labelledby", P));
      return g.createElement("svg", m({ className: s.cx(p({}, A, B != null), ae, r), height: typeof c == "number" ? c : R[c], width: typeof c == "number" ? c : R[c], role: k }, oe, H, { viewBox: "0 0 16 16" }), g.createElement("path", { d: "M13.823 2.4491C13.8201 2.30008 13.6999 2.17994 13.5509 2.17704L9.5062 2.09836C9.25654 2.09351 9.12821 2.39519 9.30482 2.5718L10.3856 3.65257L7.93433 6.10383C7.87964 6.15852 7.83047 6.21665 7.78683 6.27752L5.99909 8.06525C5.46457 8.59977 5.46457 9.4664 5.99909 10.0009C6.53361 10.5354 7.40023 10.5354 7.93475 10.0009L9.72249 8.21317C9.78336 8.16953 9.84148 8.12037 9.89618 8.06567L12.3474 5.61441L13.4282 6.69518C13.6048 6.87179 13.9065 6.74347 13.9016 6.4938L13.823 2.4491Z", fill: "currentColor" }), g.createElement("path", { d: "M7.25 3.12893C7.66421 3.12893 8 3.46472 8 3.87893C8 4.29315 7.66421 4.62893 7.25 4.62893H4C3.72386 4.62893 3.5 4.85279 3.5 5.12893V11.9929C3.5 12.2691 3.72386 12.4929 4 12.4929H10.864C11.1401 12.4929 11.364 12.2691 11.364 11.9929V8.75C11.364 8.33579 11.6998 8 12.114 8C12.5282 8 12.864 8.33579 12.864 8.75V11.9929C12.864 13.0975 11.9686 13.9929 10.864 13.9929H4C2.89543 13.9929 2 13.0975 2 11.9929V5.12893C2 4.02436 2.89543 3.12893 4 3.12893H7.25Z", fill: "currentColor" }));
    };
    return E.displayName = "OpenNewTab", E.isGlyph = !0, E.propTypes = { fill: f.default.string, size: f.default.oneOfType([f.default.number, f.default.string]), className: f.default.string }, E;
  });
})(Yr);
var ja = Yr.exports;
const ka = /* @__PURE__ */ ge(ja);
function Na(e) {
  var o = function(t, l) {
    if (typeof t != "object" || !t)
      return t;
    var s = t[Symbol.toPrimitive];
    if (s !== void 0) {
      var d = s.call(t, l || "default");
      if (typeof d != "object")
        return d;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (l === "string" ? String : Number)(t);
  }(e, "string");
  return typeof o == "symbol" ? o : o + "";
}
function C(e, o, t) {
  return (o = Na(o)) in e ? Object.defineProperty(e, o, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[o] = t, e;
}
function te() {
  return te = Object.assign ? Object.assign.bind() : function(e) {
    for (var o = 1; o < arguments.length; o++) {
      var t = arguments[o];
      for (var l in t)
        Object.prototype.hasOwnProperty.call(t, l) && (e[l] = t[l]);
    }
    return e;
  }, te.apply(this, arguments);
}
function ce(e, o) {
  if (e == null)
    return {};
  var t, l, s = function(b, g) {
    if (b == null)
      return {};
    var f, h, p = {}, m = Object.keys(b);
    for (h = 0; h < m.length; h++)
      f = m[h], g.indexOf(f) >= 0 || (p[f] = b[f]);
    return p;
  }(e, o);
  if (Object.getOwnPropertySymbols) {
    var d = Object.getOwnPropertySymbols(e);
    for (l = 0; l < d.length; l++)
      t = d[l], o.indexOf(t) >= 0 || Object.prototype.propertyIsEnumerable.call(e, t) && (s[t] = e[t]);
  }
  return s;
}
function v(e, o) {
  return o || (o = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(o) } }));
}
function Ca(e, o) {
  return function(t) {
    if (Array.isArray(t))
      return t;
  }(e) || function(t, l) {
    var s = t == null ? null : typeof Symbol < "u" && t[Symbol.iterator] || t["@@iterator"];
    if (s != null) {
      var d, b, g, f, h = [], p = !0, m = !1;
      try {
        if (g = (s = s.call(t)).next, l === 0) {
          if (Object(s) !== s)
            return;
          p = !1;
        } else
          for (; !(p = (d = g.call(s)).done) && (h.push(d.value), h.length !== l); p = !0)
            ;
      } catch (N) {
        m = !0, b = N;
      } finally {
        try {
          if (!p && s.return != null && (f = s.return(), Object(f) !== f))
            return;
        } finally {
          if (m)
            throw b;
        }
      }
      return h;
    }
  }(e, o) || function(t, l) {
    if (t) {
      if (typeof t == "string")
        return Ve(t, l);
      var s = Object.prototype.toString.call(t).slice(8, -1);
      if (s === "Object" && t.constructor && (s = t.constructor.name), s === "Map" || s === "Set")
        return Array.from(t);
      if (s === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(s))
        return Ve(t, l);
    }
  }(e, o) || function() {
    throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }();
}
function Ve(e, o) {
  (o == null || o > e.length) && (o = e.length);
  for (var t = 0, l = new Array(o); t < o; t++)
    l[t] = e[t];
  return l;
}
var qe, Ue, Ge, We, Je, Ke, Ye, Qe, xe = i(qe || (qe = v([`
  margin: unset;
  font-family: `, `;
  color: `, `;
`])), W.default, u.black), Qr = C(C({}, F.Body1, i(Ue || (Ue = v([`
    font-size: `, `px;
    line-height: `, `px;
  `])), S.body1.fontSize, S.body1.lineHeight)), F.Body2, i(Ge || (Ge = v([`
    font-size: `, `px;
    line-height: `, `px;
  `])), S.body2.fontSize, S.body2.lineHeight)), za = C(C({}, F.Body1, i(We || (We = v([`
    font-size: `, `px;
    line-height: `, `px;
  `])), S.code1.fontSize, S.code1.lineHeight)), F.Body2, i(Je || (Je = v([`
    font-size: `, `px;
    line-height: `, `px;
  `])), S.code2.fontSize, S.code2.lineHeight)), Le = C(C({}, y.Light, i(Ke || (Ke = v([`
    color: `, `;
  `])), u.black)), y.Dark, i(Ye || (Ye = v([`
    color: `, `;
  `])), u.gray.light2)), Oe = function(e) {
  var o = qr();
  return e ? e === 16 ? F.Body2 : F.Body1 : o === 16 ? F.Body2 : F.Body1;
}, La = ["baseFontSize", "darkMode", "className", "weight", "as"], Sa = X(function(e) {
  var o = e.baseFontSize, t = e.darkMode, l = e.className, s = e.weight, d = s === void 0 ? "regular" : s, b = e.as, g = b === void 0 ? "p" : b, f = ce(e, La), h = I(t).theme, p = Oe(o), m = ee(g).Component, N = i(Qe || (Qe = v([`
      font-weight: `, `;
      strong,
      b {
        font-weight: `, `;
      }
    `])), _[d], _.bold);
  return O.createElement(m, te({ className: T(xe, Qr[p], Le[h], N, l) }, f));
});
Sa.displayName = "Body";
var Xe, en, nn, tn, rn, an, on, ln, sn, cn, Ea = { label: "lg-label", description: "lg-description" };
i(Xe || (Xe = v([`
  font-family: `, `;
  font-weight: `, `;
  margin-top: 0;
  margin-bottom: 0;
`])), W.default, _.regular);
C(C({}, y.Light, i(en || (en = v([`
    color: `, `;
  `])), u.gray.dark1)), y.Dark, i(nn || (nn = v([`
    color: `, `;
  `])), u.gray.light1));
C(C({}, y.Light, i(tn || (tn = v([`
    color: `, `;
  `])), u.gray.base)), y.Dark, i(rn || (rn = v([`
    color: `, `;
  `])), u.gray.dark1));
C(C({}, F.Body1, i(an || (an = v([`
    font-size: `, `px;
    line-height: `, `px;
  `])), S.body1.fontSize, S.body1.lineHeight)), F.Body2, i(on || (on = v([`
    font-size: `, `px;
    line-height: 20px; // Hardcoding because it does not match body2 lineHeight
  `])), S.body2.fontSize));
var un, dn, fn, pn, bn;
C(C({}, y.Light, i(ln || (ln = v([`
    color: `, `;
  `])), u.gray.dark1)), y.Dark, i(sn || (sn = v([`
    color: `, `;
  `])), u.gray.light1));
i(cn || (cn = v([`
  display: block;
  font-size: 11px;
  line-height: 16px;
  letter-spacing: 0.2px;
`])));
var gn, mn, hn, yn, vn, xn, Pa = i(un || (un = v([`
  font-family: `, `;
  font-weight: `, `;
  font-size: inherit;
  line-height: inherit;

  // Unsets browser default margins
  margin-block-start: 0;
  margin-block-end: 0;
`])), W.default, _.regular), Ma = C(C({}, y.Light, i(dn || (dn = v([`
    color: `, `;
  `])), u.red.base)), y.Dark, i(fn || (fn = v([`
    color: `, `;
  `])), u.red.light1)), Da = C(C({}, F.Body1, i(pn || (pn = v([`
    font-size: `, `px;
    line-height: `, `px;
  `])), S.body1.fontSize, S.body1.lineHeight)), F.Body2, i(bn || (bn = v([`
    font-size: `, `px;
    line-height: 20px; // Hardcoding because it does not match body2 lineHeight
  `])), S.body2.fontSize)), Fa = ["as", "darkMode", "children", "className"];
X(function(e) {
  var o = e.as, t = o === void 0 ? "p" : o, l = e.darkMode, s = e.children, d = e.className, b = ce(e, Fa), g = I(l).theme, f = Oe(), h = ee(t).Component;
  return O.createElement(h, te({}, b, { className: T(Pa, Ma[g], Da[f], d) }), s);
});
var Ta = i(gn || (gn = v([`
  font-weight: `, `;
  font-size: 48px;
  line-height: 62px;
  font-family: `, `;
`])), _.regular, W.serif), Ba = C(C({}, y.Light, i(mn || (mn = v([`
    color: `, `;
  `])), u.green.dark2)), y.Dark, i(hn || (hn = v([`
    color: `, `;
  `])), u.gray.light2)), Ha = ["darkMode", "className", "as"], Aa = X(function(e) {
  var o = e.darkMode, t = e.className, l = e.as, s = l === void 0 ? "h1" : l, d = ce(e, Ha), b = I(o).theme, g = ee(s).Component;
  return O.createElement(g, te({ className: T(xe, Ta, Ba[b], t) }, d));
});
Aa.displayName = "H1";
var On, Ia = i(yn || (yn = v([`
  font-size: 32px;
  line-height: 40px;
  font-weight: `, `;
  font-family: `, `;
`])), _.regular, W.serif), Ra = C(C({}, y.Light, i(vn || (vn = v([`
    color: `, `;
  `])), u.green.dark2)), y.Dark, i(xn || (xn = v([`
    color: `, `;
  `])), u.gray.light2)), Za = ["darkMode", "className", "as"], _a = X(function(e) {
  var o = e.darkMode, t = e.className, l = e.as, s = l === void 0 ? "h2" : l, d = ce(e, Za), b = I(o).theme, g = ee(s).Component;
  return O.createElement(g, te({ className: T(xe, Ia, Ra[b], t) }, d));
});
_a.displayName = "H2";
var wn, $n, jn, kn, Nn, Cn, zn, Ln, Sn, En, Va = i(On || (On = v([`
  font-size: 24px;
  line-height: 32px;
  font-weight: `, `;
`])), _.medium), qa = ["darkMode", "className", "as"], Ua = X(function(e) {
  var o = e.darkMode, t = e.className, l = e.as, s = l === void 0 ? "h3" : l, d = ce(e, qa), b = I(o).theme, g = ee(s).Component;
  return O.createElement(g, te({ className: T(xe, Va, Le[b], t) }, d));
});
Ua.displayName = "H3";
var Pn, Mn, Dn, fe = ze(), Ga = i(wn || (wn = v([`
  display: inline;
  transition: all 0.15s ease-in-out;
  border-radius: 3px;
  font-family: `, `;
  line-height: 20px;

  .`, `:hover > & {
    text-decoration: none;
  }
`])), W.code, fe), Wa = C(C({}, y.Light, i($n || ($n = v([`
    background-color: `, `;
    border: 1px solid `, `;
    color: `, `;

    .`, `:hover > & {
      box-shadow: 0 0 0 3px `, `;
      border: 1px solid `, `;
    }
  `])), u.gray.light3, u.gray.light2, u.gray.dark3, fe, u.gray.light2, u.gray.light1)), y.Dark, i(jn || (jn = v([`
    background-color: transparent;
    border: 1px solid `, `;
    color: `, `;

    .`, `:hover > & {
      box-shadow: 0 0 0 3px `, `;
      border: 1px solid `, `;
    }
  `])), u.gray.dark2, u.gray.light1, fe, u.gray.dark2, u.gray.dark1)), Ja = C(C({}, y.Light, i(kn || (kn = v([`
    .`, `:focus-visible > & {
      box-shadow: `, `;
      border: 1px solid `, `;
    }
  `])), fe, ke[y.Light].default, u.blue.base)), y.Dark, i(Nn || (Nn = v([`
    .`, `:focus-visible > & {
      box-shadow: `, `;
      border: 1px solid `, `;
    }
  `])), fe, ke[y.Dark].default, u.blue.base)), Ka = C(C({}, y.Light, i(Cn || (Cn = v([`
    color: `, `;
  `])), u.blue.base)), y.Dark, i(zn || (zn = v([`
    color: `, `;
  `])), u.blue.light1)), Ya = i(Ln || (Ln = v([`
  text-decoration: none;
  margin: 0;
  padding: 0;
  line-height: 20px;

  &:focus {
    outline: none;
  }
`]))), Qa = i(Sn || (Sn = v([`
  white-space: nowrap;
`]))), Xa = i(En || (En = v([`
  white-space: normal;
`]))), eo = ["children", "className", "darkMode", "baseFontSize", "as"], Fn = ye(function(e, o) {
  var t, l, s = e.children, d = e.className, b = e.darkMode, g = e.baseFontSize, f = e.as, h = ce(e, eo), p = I(b).theme, m = Oe(g), N = ve(f, h, "code").Component, L = ((t = typeof s == "string" && ((l = s.match(/(?:[\0-\t\x0B\f\x0E-\u2027\u202A-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])/g)) === null || l === void 0 ? void 0 : l.length)) !== null && t !== void 0 ? t : 0) <= 30 ? Qa : Xa, M = N !== "code", D = O.createElement("code", { ref: o, className: T(za[m], Ga, Wa[p], Ja[p], L, C({}, Ka[p], M), d) }, s);
  return M ? O.createElement(N, te({ className: T(fe, Ya, d) }, h), D) : O.cloneElement(D, h);
});
Fn.displayName = "InlineCode", Fn.propTypes = { children: q.node, className: q.string, darkMode: q.bool, baseFontSize: q.oneOf(Object.values(F)) };
var Tn, Bn, Hn, An, In, Rn, Zn;
i(Pn || (Pn = v([`
  font-family: `, `;
  border: 1px solid;
  border-radius: 3px;
  padding-left: 5px;
  padding-right: 5px;
`])), W.code);
C(C({}, y.Light, i(Mn || (Mn = v([`
    color: `, `;
    border-color: `, `;
    background-color: `, `;
  `])), u.black, u.gray.dark3, u.white)), y.Dark, i(Dn || (Dn = v([`
    color: `, `;
    border-color: `, `;
    background-color: `, `;
  `])), u.gray.light2, u.gray.base, u.gray.dark3));
var _n, Vn, qn, no = i(Tn || (Tn = v([`
  font-family: `, `;
  font-weight: `, `;
`])), W.default, _.bold), to = C(C({}, y.Light, i(Bn || (Bn = v([`
    color: `, `;
  `])), u.black)), y.Dark, i(Hn || (Hn = v([`
    color: `, `;
  `])), u.gray.light2)), ro = C(C({}, y.Light, i(An || (An = v([`
    color: `, `;
  `])), u.gray.base)), y.Dark, i(In || (In = v([`
    color: `, `;
  `])), u.gray.dark1)), ao = C(C({}, F.Body1, i(Rn || (Rn = v([`
    font-size: `, `px;
    line-height: `, `px;
  `])), S.body1.fontSize, S.body1.lineHeight)), F.Body2, i(Zn || (Zn = v([`
    font-size: `, `px;
    line-height: 20px; // Hardcoding because it does not match body2 lineHeight
  `])), S.body2.fontSize)), oo = ["baseFontSize", "darkMode", "className", "children", "disabled", "as", "data-lgid"], io = X(function(e) {
  var o = e.baseFontSize, t = e.darkMode, l = e.className, s = e.children, d = e.disabled, b = d !== void 0 && d, g = e.as, f = g === void 0 ? "label" : g, h = e["data-lgid"], p = h === void 0 ? Ea.label : h, m = ce(e, oo), N = I(t).theme, L = Oe(o), M = ee(f).Component;
  return O.createElement(M, te({ "data-lgid": p, className: T(no, to[N], ao[L], C({}, ro[N], b), l) }, m), s);
});
io.displayName = "Label";
var Un, Gn, Wn, Jn, Kn, Yn, Ne = ze(), Xr = i(_n || (_n = v([`
  font-family: `, `;
  display: inline;
  align-items: center;
  text-decoration: none;
  text-decoration-color: transparent;
  cursor: pointer;
  font-size: inherit;
  line-height: inherit;
  appearance: none;
  background: none;
  border: none;
  padding: 0;

  &:hover,
  &[data-hover='true'],
  &:focus,
  &[data-focus='true'] {
    text-decoration: underline;
    transition: text-decoration `, `ms ease-in-out;
    text-underline-offset: 4px;
    text-decoration-thickness: 2px;
  }

  &:focus {
    outline: none;
  }
`])), W.default, Vr.default), ea = C(C({}, y.Light, i(Vn || (Vn = v([`
    color: `, `;
    font-weight: `, `;

    &:hover,
    &[data-hover='true'] {
      text-decoration-color: `, `;
    }

    &:focus,
    &[data-focus='true'] {
      text-decoration-color: `, `;
    }
  `])), u.blue.base, _.regular, u.gray.light2, u.blue.base)), y.Dark, i(qn || (qn = v([`
    color: `, `;
    font-weight: `, `;

    &:hover,
    &[data-hover='true'] {
      text-decoration-color: `, `;
    }

    &:focus,
    &[data-focus='true'] {
      text-decoration-color: `, `;
    }
  `])), u.blue.light1, _.bold, u.gray.dark2, u.blue.base)), na = function(e) {
  if (e)
    return Qr[e];
}, lo = i(Un || (Un = v([`
  gap: `, `px;
  display: inline-flex;
`])), U[100]), so = ["children", "className", "baseFontSize", "darkMode", "as"];
ye(function(e, o) {
  var t = e.children, l = e.className, s = e.baseFontSize, d = e.darkMode, b = e.as, g = ce(e, so), f = I(d).theme, h = Oe(s), p = ve(b, g, "span").Component;
  return O.createElement(p, te({ className: T(Ne, Xr, na(h), ea[f], lo, l), ref: o }, g), O.createElement(Oa, { role: "presentation" }), t);
});
var co = i(Gn || (Gn = v([`
  transform: translate3d(3px, 0, 0);
  top: 1px;
  position: relative;
`]))), uo = i(Wn || (Wn = v([`
  opacity: 0;
  transform: translate3d(-3px, 0, 0);
  transition: 100ms ease-in;
  transition-property: opacity, transform;
  top: 1px;
  position: relative;

  .`, ":hover &, .", `[data-hover='true'] & {
    opacity: 1;
    transform: translate3d(3px, 0, 0);
  }
`])), Ne, Ne), fo = i(Jn || (Jn = v([`
  position: relative;
  bottom: 2px;
  left: -1px;
  height: 12px;
`]))), po = "hover", bo = "persist", Qn = "none", go = ["children", "className", "arrowAppearance", "hideExternalIcon", "baseFontSize", "darkMode", "as"];
ye(function(e, o) {
  var t = e.children, l = e.className, s = e.arrowAppearance, d = s === void 0 ? Qn : s, b = e.hideExternalIcon, g = b !== void 0 && b, f = e.baseFontSize, h = e.darkMode, p = e.as, m = ce(e, go), N = Ca(Gr(""), 2), L = N[0], M = N[1];
  Ae(function() {
    M(window.location.hostname);
  }, []);
  var D, R = I(h).theme, G = Oe(f), E = ve(p, m, "span").Component, n = Wr(function() {
    if (m.href !== void 0)
      return /^http(s)?:\/\//.test(m.href) ? new URL(m.href).hostname : L;
  }, [m, L]), r = { target: void 0, rel: void 0 };
  return m.target || m.rel ? (r.target = m.target, r.rel = m.rel) : E === "a" && (n === L ? r.target = "_self" : (r.target = "_blank", r.rel = "noopener noreferrer")), r.target !== "_blank" || g ? d !== Qn && (D = O.createElement($a, { role: "presentation", size: 12, className: T(C(C({}, uo, d === po), co, d === bo)) })) : D = O.createElement(ka, { role: "presentation", className: fo }), O.createElement(E, te({ className: T(Ne, Xr, na(G), ea[R], l), ref: o }, r, m), O.createElement("span", null, t), D);
});
var mo = i(Kn || (Kn = v([`
  font-size: 12px;
  font-weight: `, `;
  text-transform: uppercase;
  line-height: 20px;
  letter-spacing: 0.4px;
`])), _.bold), ho = ["darkMode", "className", "as"], yo = X(function(e) {
  var o = e.darkMode, t = e.className, l = e.as, s = l === void 0 ? "div" : l, d = ce(e, ho), b = I(o).theme, g = ee(s).Component;
  return O.createElement(g, te({ className: T(xe, mo, Le[b], t) }, d));
});
yo.displayName = "Overline";
var vo = i(Yn || (Yn = v([`
  font-size: 18px;
  line-height: 24px;
  font-weight: `, `;
`])), _.bold), xo = ["darkMode", "className", "as"], Oo = X(function(e) {
  var o = e.darkMode, t = e.className, l = e.as, s = l === void 0 ? "h6" : l, d = ce(e, xo), b = I(o).theme, g = ee(s).Component;
  return O.createElement(g, te({ className: T(xe, vo, Le[b], t) }, d));
});
Oo.displayName = "Subtitle";
var Xn;
i(Xn || (Xn = v([`
  flex: 1;
  min-width: 0;
  max-width: 100%;

  white-space: inherit;
  overflow: inherit;
  text-overflow: inherit;
`])));
function wo(e) {
  var o = function(t, l) {
    if (typeof t != "object" || !t)
      return t;
    var s = t[Symbol.toPrimitive];
    if (s !== void 0) {
      var d = s.call(t, l || "default");
      if (typeof d != "object")
        return d;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (l === "string" ? String : Number)(t);
  }(e, "string");
  return typeof o == "symbol" ? o : o + "";
}
function se(e, o, t) {
  return (o = wo(o)) in e ? Object.defineProperty(e, o, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[o] = t, e;
}
function Z(e, o) {
  return o || (o = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(o) } }));
}
var et, nt, tt, rt, at, ot, it, lt, st, ct, ut, dt, ft, pt, bt, gt, mt, ht, yt, vt, xt, Ot, wt, $t, je = { TopLeft: "top left", TopRight: "top right", BottomRight: "bottom right" }, Te = { Center: "center", Fill: "fill" };
i(et || (et = Z([`
  position: absolute;
  z-index: -1;
`])));
se(se({}, y.Light, i(nt || (nt = Z([`
    color: `, `;
  `])), u.purple.light3)), y.Dark, i(tt || (tt = Z([`
    color: `, `;
  `])), u.gray.dark3));
se(se(se({}, je.TopLeft, { viewBox: "0 0 265 501", path: "M-10.0239 -12.0209L154.458 -12.0208C215.515 -12.0208 265 52.2446 265 131.538C265 210.041 215.934 273.615 155.523 273.467L98.8817 273.318C68.886 273.269 44.5623 304.808 44.5623 343.714L44.5623 346.186C44.5623 385.091 20.2765 416.581 -9.64308 416.581L-10.709 416.581C-40.7047 416.581 -64.9905 448.219 -64.9144 487.174C-64.8382 526.129 -89.1241 557.767 -119.12 557.767L-120.604 557.767C-150.524 557.767 -174.772 526.277 -174.81 487.421L-175 201.242C-175.038 162.336 -150.752 130.797 -120.795 130.797L-118.435 130.797C-88.477 130.797 -64.2292 99.2574 -64.2292 60.4015L-64.2292 58.3251C-64.2292 19.5186 -39.9815 -12.0209 -10.0239 -12.0209Z", styles: i(rt || (rt = Z([`
      top: 0;
      left: 0;
      width: 265px;
      max-width: 80%;
    `]))) }), je.TopRight, { viewBox: "0 0 342 368", path: "M474 92.9761L474 257.458C474 318.515 420.538 368 354.575 368C289.269 368 236.383 318.934 236.506 258.523L236.63 201.882C236.671 171.886 210.434 147.562 178.069 147.562L176.012 147.562C143.648 147.562 117.451 123.277 117.451 93.357L117.451 92.291C117.451 62.2953 91.1317 38.0095 58.7256 38.0857C26.3196 38.1618 -4.40929e-07 13.876 -3.06323e-06 -16.1197L-3.19302e-06 -17.6043C-5.80867e-06 -47.5239 26.1962 -71.7716 58.52 -71.8097L296.589 -72C328.954 -72.038 355.192 -47.7522 355.192 -17.7946L355.192 -15.4346C355.192 14.5231 381.429 38.7708 413.753 38.7708L415.48 38.7708C447.763 38.7708 474 63.0185 474 92.9761Z", styles: i(at || (at = Z([`
      top: 0;
      right: 0;
      width: 342px;
      max-width: 80%;
    `]))) }), je.BottomRight, { viewBox: "0 0 322 501", path: "M323.778 501L130.139 501C58.2575 501 -2.75101e-06 434.759 -6.14535e-06 353.027C-9.50583e-06 272.11 57.7646 206.582 128.884 206.735L195.566 206.888C230.88 206.939 259.515 174.43 259.515 134.328L259.515 131.78C259.515 91.6788 288.106 59.2206 323.33 59.2206L324.585 59.2206C359.898 59.2206 388.489 26.6094 388.399 -13.5431C388.309 -53.6956 416.901 -86.3068 452.214 -86.3068L453.961 -86.3068C489.185 -86.3068 517.731 -53.8486 517.776 -13.798L518 281.18C518.045 321.282 489.454 353.791 454.185 353.791L451.407 353.791C416.139 353.791 387.593 386.3 387.593 426.351L387.593 428.491C387.593 468.491 359.046 501 323.778 501Z", styles: i(ot || (ot = Z([`
      right: 0;
      bottom: 0;
      width: 322px;
      max-width: 70%;
    `]))) });
var $o = i(it || (it = Z([`
  padding-top: 48px;
  padding-bottom: `, `px;
`])), U[4]), jo = i(lt || (lt = Z([`
  padding-bottom: `, `px;
  position: relative;
`])), U[4]);
se(se({}, Te.Center, $o), Te.Fill, jo);
i(st || (st = Z([`
  display: flex;
  align-items: center;
  justify-content: center;
`])));
i(ct || (ct = Z([`
  width: 100%;
`])));
i(ut || (ut = Z([`
  display: block;
`])));
i(dt || (dt = Z([`
  position: absolute;
  left: 0;
  bottom: `, `px;
`])), U[4]);
se(se({}, y.Light, i(ft || (ft = Z([`
    color: `, `;
  `])), u.white)), y.Dark, i(pt || (pt = Z([`
    color: `, `;
  `])), u.black));
i(bt || (bt = Z([`
  margin-bottom: `, `px;
`])), U[1]);
i(gt || (gt = Z([`
  width: 600px;
  padding: initial;
  overflow: hidden;
`])));
i(mt || (mt = Z([`
  text-align: center;
  padding: 0 20px 32px;
  max-width: 476px;
  margin: 0 auto;
`])));
i(ht || (ht = Z([`
  font-size: `, `px;
  line-height: `, `px;
`])), S.body1.fontSize, S.body1.lineHeight);
se(se({}, y.Light, i(yt || (yt = Z([`
    color: `, `;
  `])), u.black)), y.Dark, i(vt || (vt = Z([`
    color: `, `;
  `])), u.gray.light1));
i(xt || (xt = Z([`
  line-height: 24px;
  padding-bottom: 40px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`])));
i(Ot || (Ot = Z([`
  min-width: 200px;
`])));
i(wt || (wt = Z([`
  margin-top: `, `px;
`])), U[3]);
i($t || ($t = Z([`
  padding: `, "px ", `px 0px;
  color: `, `;
`])), U[5], U[5] + U[3], u.gray.dark1);
q.element.isRequired, q.element.isRequired, q.oneOf(Object.values(Te)), q.bool, q.func, q.func, q.func, q.node, q.string, q.string.isRequired, q.string.isRequired, q.oneOf(Object.values(je)), q.bool, q.bool;
var ta = { exports: {} };
(function(e, o) {
  (function(t, l) {
    e.exports = l(O, me(), he);
  })(be, function(t, l, s) {
    function d(n) {
      return n && typeof n == "object" && "default" in n ? n : { default: n };
    }
    function b(n) {
      if (n && typeof n == "object" && "default" in n)
        return n;
      var r = /* @__PURE__ */ Object.create(null);
      return n && Object.keys(n).forEach(function(a) {
        if (a !== "default") {
          var c = Object.getOwnPropertyDescriptor(n, a);
          Object.defineProperty(r, a, c.get ? c : { enumerable: !0, get: function() {
            return n[a];
          } });
        }
      }), r.default = n, Object.freeze(r);
    }
    var g = b(t), f = d(l);
    function h(n) {
      var r = function(a, c) {
        if (typeof a != "object" || !a)
          return a;
        var w = a[Symbol.toPrimitive];
        if (w !== void 0) {
          var $ = w.call(a, c || "default");
          if (typeof $ != "object")
            return $;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }
        return (c === "string" ? String : Number)(a);
      }(n, "string");
      return typeof r == "symbol" ? r : r + "";
    }
    function p(n, r, a) {
      return (r = h(r)) in n ? Object.defineProperty(n, r, { value: a, enumerable: !0, configurable: !0, writable: !0 }) : n[r] = a, n;
    }
    function m() {
      return m = Object.assign ? Object.assign.bind() : function(n) {
        for (var r = 1; r < arguments.length; r++) {
          var a = arguments[r];
          for (var c in a)
            Object.prototype.hasOwnProperty.call(a, c) && (n[c] = a[c]);
        }
        return n;
      }, m.apply(this, arguments);
    }
    function N(n, r) {
      if (n == null)
        return {};
      var a, c, w = function(P, B) {
        if (P == null)
          return {};
        var j, k, H = {}, A = Object.keys(P);
        for (k = 0; k < A.length; k++)
          j = A[k], B.indexOf(j) >= 0 || (H[j] = P[j]);
        return H;
      }(n, r);
      if (Object.getOwnPropertySymbols) {
        var $ = Object.getOwnPropertySymbols(n);
        for (c = 0; c < $.length; c++)
          a = $[c], r.indexOf(a) >= 0 || Object.prototype.propertyIsEnumerable.call(n, a) && (w[a] = n[a]);
      }
      return w;
    }
    function L(n, r) {
      return r || (r = n.slice(0)), Object.freeze(Object.defineProperties(n, { raw: { value: Object.freeze(r) } }));
    }
    var M, D, R = { small: 14, default: 16, large: 20, xlarge: 24 }, G = ["className", "size", "title", "aria-label", "aria-labelledby", "fill", "role"], E = function(n) {
      var r = n.className, a = n.size, c = a === void 0 ? 16 : a, w = n.title, $ = n["aria-label"], P = n["aria-labelledby"], B = n.fill, j = n.role, k = j === void 0 ? "img" : j, H = N(n, G), A = s.css(M || (M = L([`
        color: `, `;
      `])), B), ae = s.css(D || (D = L([`
        flex-shrink: 0;
      `]))), oe = function(ie, le, V) {
        var J, K = V["aria-label"], Y = V["aria-labelledby"], Q = V.title;
        switch (ie) {
          case "img":
            return K || Y || Q ? p(p(p({}, "aria-labelledby", Y), "aria-label", K), "title", Q) : { "aria-label": (J = le, "".concat(J.replace(/([a-z])([A-Z])/g, "$1 $2"), " Icon")) };
          case "presentation":
            return { "aria-hidden": !0, alt: "" };
        }
      }(k, "ArrowLeft", p(p({ title: w }, "aria-label", $), "aria-labelledby", P));
      return g.createElement("svg", m({ className: s.cx(p({}, A, B != null), ae, r), height: typeof c == "number" ? c : R[c], width: typeof c == "number" ? c : R[c], role: k }, oe, H, { viewBox: "0 0 16 16" }), g.createElement("path", { d: "M13 6.83212L6.05559 6.83212L7.59059 5.29711C7.98112 4.90659 7.98112 4.27342 7.59059 3.8829L7.35168 3.64398C6.96115 3.25346 6.32799 3.25345 5.93746 3.64398L2.55483 7.02661C2.5456 7.03518 2.5365 7.04395 2.52752 7.05292L2.2886 7.29184C1.89808 7.68237 1.89808 8.31553 2.2886 8.70605L5.93975 12.3572C6.33028 12.7477 6.96344 12.7477 7.35397 12.3572L7.59288 12.1183C7.98341 11.7278 7.98341 11.0946 7.59288 10.7041L6.0588 9.17L13 9.17C13.5523 9.17 14 8.72228 14 8.17V7.83212C14 7.27983 13.5523 6.83212 13 6.83212Z", fill: "currentColor" }));
    };
    return E.displayName = "ArrowLeft", E.isGlyph = !0, E.propTypes = { fill: f.default.string, size: f.default.oneOfType([f.default.number, f.default.string]), className: f.default.string }, E;
  });
})(ta);
var ko = ta.exports;
const No = /* @__PURE__ */ ge(ko);
var ra = { exports: {} };
(function(e, o) {
  (function(t, l) {
    e.exports = l(O, me(), he);
  })(be, function(t, l, s) {
    function d(n) {
      return n && typeof n == "object" && "default" in n ? n : { default: n };
    }
    function b(n) {
      if (n && typeof n == "object" && "default" in n)
        return n;
      var r = /* @__PURE__ */ Object.create(null);
      return n && Object.keys(n).forEach(function(a) {
        if (a !== "default") {
          var c = Object.getOwnPropertyDescriptor(n, a);
          Object.defineProperty(r, a, c.get ? c : { enumerable: !0, get: function() {
            return n[a];
          } });
        }
      }), r.default = n, Object.freeze(r);
    }
    var g = b(t), f = d(l);
    function h(n) {
      var r = function(a, c) {
        if (typeof a != "object" || !a)
          return a;
        var w = a[Symbol.toPrimitive];
        if (w !== void 0) {
          var $ = w.call(a, c || "default");
          if (typeof $ != "object")
            return $;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }
        return (c === "string" ? String : Number)(a);
      }(n, "string");
      return typeof r == "symbol" ? r : r + "";
    }
    function p(n, r, a) {
      return (r = h(r)) in n ? Object.defineProperty(n, r, { value: a, enumerable: !0, configurable: !0, writable: !0 }) : n[r] = a, n;
    }
    function m() {
      return m = Object.assign ? Object.assign.bind() : function(n) {
        for (var r = 1; r < arguments.length; r++) {
          var a = arguments[r];
          for (var c in a)
            Object.prototype.hasOwnProperty.call(a, c) && (n[c] = a[c]);
        }
        return n;
      }, m.apply(this, arguments);
    }
    function N(n, r) {
      if (n == null)
        return {};
      var a, c, w = function(P, B) {
        if (P == null)
          return {};
        var j, k, H = {}, A = Object.keys(P);
        for (k = 0; k < A.length; k++)
          j = A[k], B.indexOf(j) >= 0 || (H[j] = P[j]);
        return H;
      }(n, r);
      if (Object.getOwnPropertySymbols) {
        var $ = Object.getOwnPropertySymbols(n);
        for (c = 0; c < $.length; c++)
          a = $[c], r.indexOf(a) >= 0 || Object.prototype.propertyIsEnumerable.call(n, a) && (w[a] = n[a]);
      }
      return w;
    }
    function L(n, r) {
      return r || (r = n.slice(0)), Object.freeze(Object.defineProperties(n, { raw: { value: Object.freeze(r) } }));
    }
    var M, D, R = { small: 14, default: 16, large: 20, xlarge: 24 }, G = ["className", "size", "title", "aria-label", "aria-labelledby", "fill", "role"], E = function(n) {
      var r = n.className, a = n.size, c = a === void 0 ? 16 : a, w = n.title, $ = n["aria-label"], P = n["aria-labelledby"], B = n.fill, j = n.role, k = j === void 0 ? "img" : j, H = N(n, G), A = s.css(M || (M = L([`
        color: `, `;
      `])), B), ae = s.css(D || (D = L([`
        flex-shrink: 0;
      `]))), oe = function(ie, le, V) {
        var J, K = V["aria-label"], Y = V["aria-labelledby"], Q = V.title;
        switch (ie) {
          case "img":
            return K || Y || Q ? p(p(p({}, "aria-labelledby", Y), "aria-label", K), "title", Q) : { "aria-label": (J = le, "".concat(J.replace(/([a-z])([A-Z])/g, "$1 $2"), " Icon")) };
          case "presentation":
            return { "aria-hidden": !0, alt: "" };
        }
      }(k, "ArrowRight", p(p({ title: w }, "aria-label", $), "aria-labelledby", P));
      return g.createElement("svg", m({ className: s.cx(p({}, A, B != null), ae, r), height: typeof c == "number" ? c : R[c], width: typeof c == "number" ? c : R[c], role: k }, oe, H, { viewBox: "0 0 16 16" }), g.createElement("path", { d: "M3 6.83212L9.94442 6.83212L8.40941 5.29711C8.01888 4.90659 8.01889 4.27342 8.40941 3.8829L8.64833 3.64398C9.03885 3.25346 9.67201 3.25345 10.0625 3.64398L13.4452 7.02661C13.4544 7.03518 13.4635 7.04395 13.4725 7.05292L13.7114 7.29184C14.1019 7.68237 14.1019 8.31553 13.7114 8.70605L10.0602 12.3572C9.66972 12.7477 9.03656 12.7477 8.64603 12.3572L8.40712 12.1183C8.01659 11.7278 8.01659 11.0946 8.40712 10.7041L9.9412 9.17L3 9.17C2.44771 9.17 2 8.72228 2 8.17L2 7.83212C2 7.27983 2.44772 6.83212 3 6.83212Z", fill: "currentColor" }));
    };
    return E.displayName = "ArrowRight", E.isGlyph = !0, E.propTypes = { fill: f.default.string, size: f.default.oneOfType([f.default.number, f.default.string]), className: f.default.string }, E;
  });
})(ra);
var Co = ra.exports;
const zo = /* @__PURE__ */ ge(Co);
var aa = { exports: {} };
(function(e, o) {
  (function(t, l) {
    e.exports = l(O, me(), he);
  })(be, function(t, l, s) {
    function d(n) {
      return n && typeof n == "object" && "default" in n ? n : { default: n };
    }
    function b(n) {
      if (n && typeof n == "object" && "default" in n)
        return n;
      var r = /* @__PURE__ */ Object.create(null);
      return n && Object.keys(n).forEach(function(a) {
        if (a !== "default") {
          var c = Object.getOwnPropertyDescriptor(n, a);
          Object.defineProperty(r, a, c.get ? c : { enumerable: !0, get: function() {
            return n[a];
          } });
        }
      }), r.default = n, Object.freeze(r);
    }
    var g = b(t), f = d(l);
    function h(n) {
      var r = function(a, c) {
        if (typeof a != "object" || !a)
          return a;
        var w = a[Symbol.toPrimitive];
        if (w !== void 0) {
          var $ = w.call(a, c || "default");
          if (typeof $ != "object")
            return $;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }
        return (c === "string" ? String : Number)(a);
      }(n, "string");
      return typeof r == "symbol" ? r : r + "";
    }
    function p(n, r, a) {
      return (r = h(r)) in n ? Object.defineProperty(n, r, { value: a, enumerable: !0, configurable: !0, writable: !0 }) : n[r] = a, n;
    }
    function m() {
      return m = Object.assign ? Object.assign.bind() : function(n) {
        for (var r = 1; r < arguments.length; r++) {
          var a = arguments[r];
          for (var c in a)
            Object.prototype.hasOwnProperty.call(a, c) && (n[c] = a[c]);
        }
        return n;
      }, m.apply(this, arguments);
    }
    function N(n, r) {
      if (n == null)
        return {};
      var a, c, w = function(P, B) {
        if (P == null)
          return {};
        var j, k, H = {}, A = Object.keys(P);
        for (k = 0; k < A.length; k++)
          j = A[k], B.indexOf(j) >= 0 || (H[j] = P[j]);
        return H;
      }(n, r);
      if (Object.getOwnPropertySymbols) {
        var $ = Object.getOwnPropertySymbols(n);
        for (c = 0; c < $.length; c++)
          a = $[c], r.indexOf(a) >= 0 || Object.prototype.propertyIsEnumerable.call(n, a) && (w[a] = n[a]);
      }
      return w;
    }
    function L(n, r) {
      return r || (r = n.slice(0)), Object.freeze(Object.defineProperties(n, { raw: { value: Object.freeze(r) } }));
    }
    var M, D, R = { small: 14, default: 16, large: 20, xlarge: 24 }, G = ["className", "size", "title", "aria-label", "aria-labelledby", "fill", "role"], E = function(n) {
      var r = n.className, a = n.size, c = a === void 0 ? 16 : a, w = n.title, $ = n["aria-label"], P = n["aria-labelledby"], B = n.fill, j = n.role, k = j === void 0 ? "img" : j, H = N(n, G), A = s.css(M || (M = L([`
        color: `, `;
      `])), B), ae = s.css(D || (D = L([`
        flex-shrink: 0;
      `]))), oe = function(ie, le, V) {
        var J, K = V["aria-label"], Y = V["aria-labelledby"], Q = V.title;
        switch (ie) {
          case "img":
            return K || Y || Q ? p(p(p({}, "aria-labelledby", Y), "aria-label", K), "title", Q) : { "aria-label": (J = le, "".concat(J.replace(/([a-z])([A-Z])/g, "$1 $2"), " Icon")) };
          case "presentation":
            return { "aria-hidden": !0, alt: "" };
        }
      }(k, "OpenNewTab", p(p({ title: w }, "aria-label", $), "aria-labelledby", P));
      return g.createElement("svg", m({ className: s.cx(p({}, A, B != null), ae, r), height: typeof c == "number" ? c : R[c], width: typeof c == "number" ? c : R[c], role: k }, oe, H, { viewBox: "0 0 16 16" }), g.createElement("path", { d: "M13.823 2.4491C13.8201 2.30008 13.6999 2.17994 13.5509 2.17704L9.5062 2.09836C9.25654 2.09351 9.12821 2.39519 9.30482 2.5718L10.3856 3.65257L7.93433 6.10383C7.87964 6.15852 7.83047 6.21665 7.78683 6.27752L5.99909 8.06525C5.46457 8.59977 5.46457 9.4664 5.99909 10.0009C6.53361 10.5354 7.40023 10.5354 7.93475 10.0009L9.72249 8.21317C9.78336 8.16953 9.84148 8.12037 9.89618 8.06567L12.3474 5.61441L13.4282 6.69518C13.6048 6.87179 13.9065 6.74347 13.9016 6.4938L13.823 2.4491Z", fill: "currentColor" }), g.createElement("path", { d: "M7.25 3.12893C7.66421 3.12893 8 3.46472 8 3.87893C8 4.29315 7.66421 4.62893 7.25 4.62893H4C3.72386 4.62893 3.5 4.85279 3.5 5.12893V11.9929C3.5 12.2691 3.72386 12.4929 4 12.4929H10.864C11.1401 12.4929 11.364 12.2691 11.364 11.9929V8.75C11.364 8.33579 11.6998 8 12.114 8C12.5282 8 12.864 8.33579 12.864 8.75V11.9929C12.864 13.0975 11.9686 13.9929 10.864 13.9929H4C2.89543 13.9929 2 13.0975 2 11.9929V5.12893C2 4.02436 2.89543 3.12893 4 3.12893H7.25Z", fill: "currentColor" }));
    };
    return E.displayName = "OpenNewTab", E.isGlyph = !0, E.propTypes = { fill: f.default.string, size: f.default.oneOfType([f.default.number, f.default.string]), className: f.default.string }, E;
  });
})(aa);
var Lo = aa.exports;
const So = /* @__PURE__ */ ge(Lo);
function Eo(e) {
  var o = function(t, l) {
    if (typeof t != "object" || !t)
      return t;
    var s = t[Symbol.toPrimitive];
    if (s !== void 0) {
      var d = s.call(t, l || "default");
      if (typeof d != "object")
        return d;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (l === "string" ? String : Number)(t);
  }(e, "string");
  return typeof o == "symbol" ? o : o + "";
}
function z(e, o, t) {
  return (o = Eo(o)) in e ? Object.defineProperty(e, o, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[o] = t, e;
}
function ne() {
  return ne = Object.assign ? Object.assign.bind() : function(e) {
    for (var o = 1; o < arguments.length; o++) {
      var t = arguments[o];
      for (var l in t)
        Object.prototype.hasOwnProperty.call(t, l) && (e[l] = t[l]);
    }
    return e;
  }, ne.apply(this, arguments);
}
function re(e, o) {
  if (e == null)
    return {};
  var t, l, s = function(b, g) {
    if (b == null)
      return {};
    var f, h, p = {}, m = Object.keys(b);
    for (h = 0; h < m.length; h++)
      f = m[h], g.indexOf(f) >= 0 || (p[f] = b[f]);
    return p;
  }(e, o);
  if (Object.getOwnPropertySymbols) {
    var d = Object.getOwnPropertySymbols(e);
    for (l = 0; l < d.length; l++)
      t = d[l], o.indexOf(t) >= 0 || Object.prototype.propertyIsEnumerable.call(e, t) && (s[t] = e[t]);
  }
  return s;
}
function x(e, o) {
  return o || (o = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(o) } }));
}
function Po(e, o) {
  return function(t) {
    if (Array.isArray(t))
      return t;
  }(e) || function(t, l) {
    var s = t == null ? null : typeof Symbol < "u" && t[Symbol.iterator] || t["@@iterator"];
    if (s != null) {
      var d, b, g, f, h = [], p = !0, m = !1;
      try {
        if (g = (s = s.call(t)).next, l === 0) {
          if (Object(s) !== s)
            return;
          p = !1;
        } else
          for (; !(p = (d = g.call(s)).done) && (h.push(d.value), h.length !== l); p = !0)
            ;
      } catch (N) {
        m = !0, b = N;
      } finally {
        try {
          if (!p && s.return != null && (f = s.return(), Object(f) !== f))
            return;
        } finally {
          if (m)
            throw b;
        }
      }
      return h;
    }
  }(e, o) || function(t, l) {
    if (t) {
      if (typeof t == "string")
        return jt(t, l);
      var s = Object.prototype.toString.call(t).slice(8, -1);
      if (s === "Object" && t.constructor && (s = t.constructor.name), s === "Map" || s === "Set")
        return Array.from(t);
      if (s === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(s))
        return jt(t, l);
    }
  }(e, o) || function() {
    throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }();
}
function jt(e, o) {
  (o == null || o > e.length) && (o = e.length);
  for (var t = 0, l = new Array(o); t < o; t++)
    l[t] = e[t];
  return l;
}
var kt, Nt, Ct, zt, Lt, St, Et, Pt, de = i(kt || (kt = x([`
  margin: unset;
  font-family: `, `;
  color: `, `;
`])), W.default, u.black), oa = z(z({}, F.Body1, i(Nt || (Nt = x([`
    font-size: `, `px;
    line-height: `, `px;
  `])), S.body1.fontSize, S.body1.lineHeight)), F.Body2, i(Ct || (Ct = x([`
    font-size: `, `px;
    line-height: `, `px;
  `])), S.body2.fontSize, S.body2.lineHeight)), Mo = z(z({}, F.Body1, i(zt || (zt = x([`
    font-size: `, `px;
    line-height: `, `px;
  `])), S.code1.fontSize, S.code1.lineHeight)), F.Body2, i(Lt || (Lt = x([`
    font-size: `, `px;
    line-height: `, `px;
  `])), S.code2.fontSize, S.code2.lineHeight)), Se = z(z({}, y.Light, i(St || (St = x([`
    color: `, `;
  `])), u.black)), y.Dark, i(Et || (Et = x([`
    color: `, `;
  `])), u.gray.light2)), we = function(e) {
  var o = qr();
  return e ? e === 16 ? F.Body2 : F.Body1 : o === 16 ? F.Body2 : F.Body1;
}, Do = ["baseFontSize", "darkMode", "className", "weight", "as"], ia = X(function(e) {
  var o = e.baseFontSize, t = e.darkMode, l = e.className, s = e.weight, d = s === void 0 ? "regular" : s, b = e.as, g = b === void 0 ? "p" : b, f = re(e, Do), h = I(t).theme, p = we(o), m = ee(g).Component, N = i(Pt || (Pt = x([`
      font-weight: `, `;
      strong,
      b {
        font-weight: `, `;
      }
    `])), _[d], _.bold);
  return O.createElement(m, ne({ className: T(de, oa[p], Se[h], N, l) }, f));
});
ia.displayName = "Body";
var Mt, Dt, Ft, Tt, Bt, Ht, At, It, Rt, Zt, Fo = { label: "lg-label", description: "lg-description" };
i(Mt || (Mt = x([`
  font-family: `, `;
  font-weight: `, `;
  margin-top: 0;
  margin-bottom: 0;
`])), W.default, _.regular);
z(z({}, y.Light, i(Dt || (Dt = x([`
    color: `, `;
  `])), u.gray.dark1)), y.Dark, i(Ft || (Ft = x([`
    color: `, `;
  `])), u.gray.light1));
z(z({}, y.Light, i(Tt || (Tt = x([`
    color: `, `;
  `])), u.gray.base)), y.Dark, i(Bt || (Bt = x([`
    color: `, `;
  `])), u.gray.dark1));
z(z({}, F.Body1, i(Ht || (Ht = x([`
    font-size: `, `px;
    line-height: `, `px;
  `])), S.body1.fontSize, S.body1.lineHeight)), F.Body2, i(At || (At = x([`
    font-size: `, `px;
    line-height: 20px; // Hardcoding because it does not match body2 lineHeight
  `])), S.body2.fontSize));
var _t, Vt, qt, Ut, Gt, To = z(z({}, y.Light, i(It || (It = x([`
    color: `, `;
  `])), u.gray.dark1)), y.Dark, i(Rt || (Rt = x([`
    color: `, `;
  `])), u.gray.light1)), Bo = i(Zt || (Zt = x([`
  display: block;
  font-size: 11px;
  line-height: 16px;
  letter-spacing: 0.2px;
`]))), Ho = ["darkMode", "children", "className"];
function la(e) {
  var o = e.darkMode, t = e.children, l = e.className, s = re(e, Ho), d = I(o).theme;
  return O.createElement("small", ne({}, s, { className: T(de, Bo, To[d], l) }), t);
}
la.displayName = "Disclaimer";
var Wt, Jt, Kt, Yt, Qt, Xt, Ao = i(_t || (_t = x([`
  font-family: `, `;
  font-weight: `, `;
  font-size: inherit;
  line-height: inherit;

  // Unsets browser default margins
  margin-block-start: 0;
  margin-block-end: 0;
`])), W.default, _.regular), Io = z(z({}, y.Light, i(Vt || (Vt = x([`
    color: `, `;
  `])), u.red.base)), y.Dark, i(qt || (qt = x([`
    color: `, `;
  `])), u.red.light1)), Ro = z(z({}, F.Body1, i(Ut || (Ut = x([`
    font-size: `, `px;
    line-height: `, `px;
  `])), S.body1.fontSize, S.body1.lineHeight)), F.Body2, i(Gt || (Gt = x([`
    font-size: `, `px;
    line-height: 20px; // Hardcoding because it does not match body2 lineHeight
  `])), S.body2.fontSize)), Zo = ["as", "darkMode", "children", "className"];
X(function(e) {
  var o = e.as, t = o === void 0 ? "p" : o, l = e.darkMode, s = e.children, d = e.className, b = re(e, Zo), g = I(l).theme, f = we(), h = ee(t).Component;
  return O.createElement(h, ne({}, b, { className: T(Ao, Io[g], Ro[f], d) }), s);
});
var _o = i(Wt || (Wt = x([`
  font-weight: `, `;
  font-size: 48px;
  line-height: 62px;
  font-family: `, `;
`])), _.regular, W.serif), Vo = z(z({}, y.Light, i(Jt || (Jt = x([`
    color: `, `;
  `])), u.green.dark2)), y.Dark, i(Kt || (Kt = x([`
    color: `, `;
  `])), u.gray.light2)), qo = ["darkMode", "className", "as"], Uo = X(function(e) {
  var o = e.darkMode, t = e.className, l = e.as, s = l === void 0 ? "h1" : l, d = re(e, qo), b = I(o).theme, g = ee(s).Component;
  return O.createElement(g, ne({ className: T(de, _o, Vo[b], t) }, d));
});
Uo.displayName = "H1";
var er, Go = i(Yt || (Yt = x([`
  font-size: 32px;
  line-height: 40px;
  font-weight: `, `;
  font-family: `, `;
`])), _.regular, W.serif), Wo = z(z({}, y.Light, i(Qt || (Qt = x([`
    color: `, `;
  `])), u.green.dark2)), y.Dark, i(Xt || (Xt = x([`
    color: `, `;
  `])), u.gray.light2)), Jo = ["darkMode", "className", "as"], Ko = X(function(e) {
  var o = e.darkMode, t = e.className, l = e.as, s = l === void 0 ? "h2" : l, d = re(e, Jo), b = I(o).theme, g = ee(s).Component;
  return O.createElement(g, ne({ className: T(de, Go, Wo[b], t) }, d));
});
Ko.displayName = "H2";
var nr, tr, rr, ar, or, ir, lr, sr, cr, ur, Yo = i(er || (er = x([`
  font-size: 24px;
  line-height: 32px;
  font-weight: `, `;
`])), _.medium), Qo = ["darkMode", "className", "as"], Xo = X(function(e) {
  var o = e.darkMode, t = e.className, l = e.as, s = l === void 0 ? "h3" : l, d = re(e, Qo), b = I(o).theme, g = ee(s).Component;
  return O.createElement(g, ne({ className: T(de, Yo, Se[b], t) }, d));
});
Xo.displayName = "H3";
var dr, fr, pr, pe = ze(), ei = i(nr || (nr = x([`
  display: inline;
  transition: all 0.15s ease-in-out;
  border-radius: 3px;
  font-family: `, `;
  line-height: 20px;

  .`, `:hover > & {
    text-decoration: none;
  }
`])), W.code, pe), ni = z(z({}, y.Light, i(tr || (tr = x([`
    background-color: `, `;
    border: 1px solid `, `;
    color: `, `;

    .`, `:hover > & {
      box-shadow: 0 0 0 3px `, `;
      border: 1px solid `, `;
    }
  `])), u.gray.light3, u.gray.light2, u.gray.dark3, pe, u.gray.light2, u.gray.light1)), y.Dark, i(rr || (rr = x([`
    background-color: transparent;
    border: 1px solid `, `;
    color: `, `;

    .`, `:hover > & {
      box-shadow: 0 0 0 3px `, `;
      border: 1px solid `, `;
    }
  `])), u.gray.dark2, u.gray.light1, pe, u.gray.dark2, u.gray.dark1)), ti = z(z({}, y.Light, i(ar || (ar = x([`
    .`, `:focus-visible > & {
      box-shadow: `, `;
      border: 1px solid `, `;
    }
  `])), pe, ke[y.Light].default, u.blue.base)), y.Dark, i(or || (or = x([`
    .`, `:focus-visible > & {
      box-shadow: `, `;
      border: 1px solid `, `;
    }
  `])), pe, ke[y.Dark].default, u.blue.base)), ri = z(z({}, y.Light, i(ir || (ir = x([`
    color: `, `;
  `])), u.blue.base)), y.Dark, i(lr || (lr = x([`
    color: `, `;
  `])), u.blue.light1)), ai = i(sr || (sr = x([`
  text-decoration: none;
  margin: 0;
  padding: 0;
  line-height: 20px;

  &:focus {
    outline: none;
  }
`]))), oi = i(cr || (cr = x([`
  white-space: nowrap;
`]))), ii = i(ur || (ur = x([`
  white-space: normal;
`]))), li = ["children", "className", "darkMode", "baseFontSize", "as"], br = ye(function(e, o) {
  var t, l, s = e.children, d = e.className, b = e.darkMode, g = e.baseFontSize, f = e.as, h = re(e, li), p = I(b).theme, m = we(g), N = ve(f, h, "code").Component, L = ((t = typeof s == "string" && ((l = s.match(/(?:[\0-\t\x0B\f\x0E-\u2027\u202A-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])/g)) === null || l === void 0 ? void 0 : l.length)) !== null && t !== void 0 ? t : 0) <= 30 ? oi : ii, M = N !== "code", D = O.createElement("code", { ref: o, className: T(Mo[m], ei, ni[p], ti[p], L, z({}, ri[p], M), d) }, s);
  return M ? O.createElement(N, ne({ className: T(pe, ai, d) }, h), D) : O.cloneElement(D, h);
});
br.displayName = "InlineCode", br.propTypes = { children: q.node, className: q.string, darkMode: q.bool, baseFontSize: q.oneOf(Object.values(F)) };
var gr, mr, hr, yr, vr, xr, Or;
i(dr || (dr = x([`
  font-family: `, `;
  border: 1px solid;
  border-radius: 3px;
  padding-left: 5px;
  padding-right: 5px;
`])), W.code);
z(z({}, y.Light, i(fr || (fr = x([`
    color: `, `;
    border-color: `, `;
    background-color: `, `;
  `])), u.black, u.gray.dark3, u.white)), y.Dark, i(pr || (pr = x([`
    color: `, `;
    border-color: `, `;
    background-color: `, `;
  `])), u.gray.light2, u.gray.base, u.gray.dark3));
var wr, $r, jr, si = i(gr || (gr = x([`
  font-family: `, `;
  font-weight: `, `;
`])), W.default, _.bold), ci = z(z({}, y.Light, i(mr || (mr = x([`
    color: `, `;
  `])), u.black)), y.Dark, i(hr || (hr = x([`
    color: `, `;
  `])), u.gray.light2)), ui = z(z({}, y.Light, i(yr || (yr = x([`
    color: `, `;
  `])), u.gray.base)), y.Dark, i(vr || (vr = x([`
    color: `, `;
  `])), u.gray.dark1)), di = z(z({}, F.Body1, i(xr || (xr = x([`
    font-size: `, `px;
    line-height: `, `px;
  `])), S.body1.fontSize, S.body1.lineHeight)), F.Body2, i(Or || (Or = x([`
    font-size: `, `px;
    line-height: 20px; // Hardcoding because it does not match body2 lineHeight
  `])), S.body2.fontSize)), fi = ["baseFontSize", "darkMode", "className", "children", "disabled", "as", "data-lgid"], pi = X(function(e) {
  var o = e.baseFontSize, t = e.darkMode, l = e.className, s = e.children, d = e.disabled, b = d !== void 0 && d, g = e.as, f = g === void 0 ? "label" : g, h = e["data-lgid"], p = h === void 0 ? Fo.label : h, m = re(e, fi), N = I(t).theme, L = we(o), M = ee(f).Component;
  return O.createElement(M, ne({ "data-lgid": p, className: T(si, ci[N], di[L], z({}, ui[N], b), l) }, m), s);
});
pi.displayName = "Label";
var kr, Nr, Cr, zr, Lr, Sr, Ce = ze(), sa = i(wr || (wr = x([`
  font-family: `, `;
  display: inline;
  align-items: center;
  text-decoration: none;
  text-decoration-color: transparent;
  cursor: pointer;
  font-size: inherit;
  line-height: inherit;
  appearance: none;
  background: none;
  border: none;
  padding: 0;

  &:hover,
  &[data-hover='true'],
  &:focus,
  &[data-focus='true'] {
    text-decoration: underline;
    transition: text-decoration `, `ms ease-in-out;
    text-underline-offset: 4px;
    text-decoration-thickness: 2px;
  }

  &:focus {
    outline: none;
  }
`])), W.default, Vr.default), ca = z(z({}, y.Light, i($r || ($r = x([`
    color: `, `;
    font-weight: `, `;

    &:hover,
    &[data-hover='true'] {
      text-decoration-color: `, `;
    }

    &:focus,
    &[data-focus='true'] {
      text-decoration-color: `, `;
    }
  `])), u.blue.base, _.regular, u.gray.light2, u.blue.base)), y.Dark, i(jr || (jr = x([`
    color: `, `;
    font-weight: `, `;

    &:hover,
    &[data-hover='true'] {
      text-decoration-color: `, `;
    }

    &:focus,
    &[data-focus='true'] {
      text-decoration-color: `, `;
    }
  `])), u.blue.light1, _.bold, u.gray.dark2, u.blue.base)), ua = function(e) {
  if (e)
    return oa[e];
}, bi = i(kr || (kr = x([`
  gap: `, `px;
  display: inline-flex;
`])), U[100]), gi = ["children", "className", "baseFontSize", "darkMode", "as"];
ye(function(e, o) {
  var t = e.children, l = e.className, s = e.baseFontSize, d = e.darkMode, b = e.as, g = re(e, gi), f = I(d).theme, h = we(s), p = ve(b, g, "span").Component;
  return O.createElement(p, ne({ className: T(Ce, sa, ua(h), ca[f], bi, l), ref: o }, g), O.createElement(No, { role: "presentation" }), t);
});
var mi = i(Nr || (Nr = x([`
  transform: translate3d(3px, 0, 0);
  top: 1px;
  position: relative;
`]))), hi = i(Cr || (Cr = x([`
  opacity: 0;
  transform: translate3d(-3px, 0, 0);
  transition: 100ms ease-in;
  transition-property: opacity, transform;
  top: 1px;
  position: relative;

  .`, ":hover &, .", `[data-hover='true'] & {
    opacity: 1;
    transform: translate3d(3px, 0, 0);
  }
`])), Ce, Ce), yi = i(zr || (zr = x([`
  position: relative;
  bottom: 2px;
  left: -1px;
  height: 12px;
`]))), vi = "hover", xi = "persist", Er = "none", Oi = ["children", "className", "arrowAppearance", "hideExternalIcon", "baseFontSize", "darkMode", "as"];
ye(function(e, o) {
  var t = e.children, l = e.className, s = e.arrowAppearance, d = s === void 0 ? Er : s, b = e.hideExternalIcon, g = b !== void 0 && b, f = e.baseFontSize, h = e.darkMode, p = e.as, m = re(e, Oi), N = Po(Gr(""), 2), L = N[0], M = N[1];
  Ae(function() {
    M(window.location.hostname);
  }, []);
  var D, R = I(h).theme, G = we(f), E = ve(p, m, "span").Component, n = Wr(function() {
    if (m.href !== void 0)
      return /^http(s)?:\/\//.test(m.href) ? new URL(m.href).hostname : L;
  }, [m, L]), r = { target: void 0, rel: void 0 };
  return m.target || m.rel ? (r.target = m.target, r.rel = m.rel) : E === "a" && (n === L ? r.target = "_self" : (r.target = "_blank", r.rel = "noopener noreferrer")), r.target !== "_blank" || g ? d !== Er && (D = O.createElement(zo, { role: "presentation", size: 12, className: T(z(z({}, hi, d === vi), mi, d === xi)) })) : D = O.createElement(So, { role: "presentation", className: yi }), O.createElement(E, ne({ className: T(Ce, sa, ua(G), ca[R], l), ref: o }, r, m), O.createElement("span", null, t), D);
});
var wi = i(Lr || (Lr = x([`
  font-size: 12px;
  font-weight: `, `;
  text-transform: uppercase;
  line-height: 20px;
  letter-spacing: 0.4px;
`])), _.bold), $i = ["darkMode", "className", "as"], ji = X(function(e) {
  var o = e.darkMode, t = e.className, l = e.as, s = l === void 0 ? "div" : l, d = re(e, $i), b = I(o).theme, g = ee(s).Component;
  return O.createElement(g, ne({ className: T(de, wi, Se[b], t) }, d));
});
ji.displayName = "Overline";
var ki = i(Sr || (Sr = x([`
  font-size: 18px;
  line-height: 24px;
  font-weight: `, `;
`])), _.bold), Ni = ["darkMode", "className", "as"], Ci = X(function(e) {
  var o = e.darkMode, t = e.className, l = e.as, s = l === void 0 ? "h6" : l, d = re(e, Ni), b = I(o).theme, g = ee(s).Component;
  return O.createElement(g, ne({ className: T(de, ki, Se[b], t) }, d));
});
Ci.displayName = "Subtitle";
var Pr;
i(Pr || (Pr = x([`
  flex: 1;
  min-width: 0;
  max-width: 100%;

  white-space: inherit;
  overflow: inherit;
  text-overflow: inherit;
`])));
var Mr;
function zi(e, o) {
  if (e == null)
    return {};
  var t, l, s = function(b, g) {
    if (b == null)
      return {};
    var f, h, p = {}, m = Object.keys(b);
    for (h = 0; h < m.length; h++)
      f = m[h], g.indexOf(f) >= 0 || (p[f] = b[f]);
    return p;
  }(e, o);
  if (Object.getOwnPropertySymbols) {
    var d = Object.getOwnPropertySymbols(e);
    for (l = 0; l < d.length; l++)
      t = d[l], o.indexOf(t) >= 0 || Object.prototype.propertyIsEnumerable.call(e, t) && (s[t] = e[t]);
  }
  return s;
}
var Pe, Me, Li = i(Mr || (Pe = [`
  margin-bottom: `, `px;
`], Me || (Me = Pe.slice(0)), Mr = Object.freeze(Object.defineProperties(Pe, { raw: { value: Object.freeze(Me) } }))), U[2]), Si = ["title", "children"], da = function(e) {
  var o = e.title, t = e.children, l = zi(e, Si);
  return O.createElement("div", l, o && O.createElement(ia, { weight: "medium", className: Li }, o), O.createElement(la, null, t));
};
da.displayName = "DisclaimerText";
function $e(e, o, t) {
  return (o = function(l) {
    var s = function(d, b) {
      if (typeof d != "object" || d === null)
        return d;
      var g = d[Symbol.toPrimitive];
      if (g !== void 0) {
        var f = g.call(d, b || "default");
        if (typeof f != "object")
          return f;
        throw new TypeError("@@toPrimitive must return a primitive value.");
      }
      return (b === "string" ? String : Number)(d);
    }(l, "string");
    return typeof s == "symbol" ? s : String(s);
  }(o)) in e ? Object.defineProperty(e, o, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[o] = t, e;
}
function Be() {
  return Be = Object.assign ? Object.assign.bind() : function(e) {
    for (var o = 1; o < arguments.length; o++) {
      var t = arguments[o];
      for (var l in t)
        Object.prototype.hasOwnProperty.call(t, l) && (e[l] = t[l]);
    }
    return e;
  }, Be.apply(this, arguments);
}
function Ei(e, o) {
  if (e == null)
    return {};
  var t, l, s = function(b, g) {
    if (b == null)
      return {};
    var f, h, p = {}, m = Object.keys(b);
    for (h = 0; h < m.length; h++)
      f = m[h], g.indexOf(f) >= 0 || (p[f] = b[f]);
    return p;
  }(e, o);
  if (Object.getOwnPropertySymbols) {
    var d = Object.getOwnPropertySymbols(e);
    for (l = 0; l < d.length; l++)
      t = d[l], o.indexOf(t) >= 0 || Object.prototype.propertyIsEnumerable.call(e, t) && (s[t] = e[t]);
  }
  return s;
}
function ue(e, o) {
  return o || (o = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(o) } }));
}
var Dr, Fr, Tr, De, Br, Hr, Ar, Fe, Ir, Rr, Zr, Pi = i(Dr || (Dr = ue([`
  height: 500px;
  width: 100%;
  display: flex;
  justify-content: center;
`]))), Mi = ($e(De = {}, y.Dark, i(Fr || (Fr = ue([`
    background-color: `, `;
  `])), u.black)), $e(De, y.Light, i(Tr || (Tr = ue([`
    background-color: `, `;
  `])), u.gray.light3)), De), Di = i(Br || (Br = ue([`
  width: 100%;
  max-width: `, `px;
  height: 100%;
  overflow-y: scroll;
  scroll-behavior: smooth;
  position: relative;
  padding: `, "px ", "px ", `px;
  z-index: 2;
`])), Ur.Tablet + 2 * (Ie[Re.Default] + U[5] + U[3]), U[3], U[5], U[2]), Fi = ($e(Fe = {}, y.Dark, i(Hr || (Hr = ue([`
    // https://css-tricks.com/books/greatest-css-tricks/scroll-shadows/
    background:
      /* Shadow Cover TOP */ 
      // eslint-disable-next-line Maintain natural line break
      linear-gradient(`, " 30%, ", ` 0%) center top,
      /* Shadow Cover BOTTOM */
        linear-gradient(`, " 0%, ", ` 70%) center bottom,
      /* Shadow TOP */
        radial-gradient(
          farthest-side at 50% 0,
          rgba(0, 0, 0, 0.3),
          rgba(0, 0, 0, 0)
        )
        center top,
      /* Shadow BOTTOM */
        radial-gradient(
          farthest-side at 50% 100%,
          rgba(0, 0, 0, 0.3),
          rgba(0, 0, 0, 0)
        )
        center bottom;
    background-repeat: no-repeat;
    background-size: 100% 16px, 100% 16px, 100% 8px, 100% 8px;
    background-attachment: local, local, scroll, scroll;
  `])), u.black, u.black, u.black, u.black)), $e(Fe, y.Light, i(Ar || (Ar = ue([`
    // https://css-tricks.com/books/greatest-css-tricks/scroll-shadows/
    background:
      /* Shadow Cover TOP */ 
      // eslint-disable-next-line Maintain natural line break
      linear-gradient(`, " 30%, ", ` 0%)
        center top,
      /* Shadow Cover BOTTOM */
        linear-gradient(`, " 0%, ", ` 30%)
        center bottom,
      /* Shadow TOP */
        radial-gradient(
          farthest-side at 50% 0,
          rgba(0, 0, 0, 0.1),
          rgba(0, 0, 0, 0)
        )
        center top,
      /* Shadow BOTTOM */
        radial-gradient(
          farthest-side at 50% 100%,
          rgba(0, 0, 0, 0.1),
          rgba(0, 0, 0, 0)
        )
        center bottom;
    background-repeat: no-repeat;
    background-size: 100% 16px, 100% 16px, 100% 8px, 100% 8px;
    background-attachment: local, local, scroll, scroll;
  `])), u.gray.light3, u.gray.light3, u.gray.light3, u.gray.light3)), Fe), Ti = i(Ir || (Ir = ue([`
  padding: 0px `, `px;
`])), Ie[Re.Small] + U[2]), Bi = i(Rr || (Rr = ue([`
  padding: 0px `, `px;
`])), Ie[Re.Default] + U[3]), Hi = i(Zr || (Zr = ue([`
  text-align: center;
  margin-top: `, `px;
  margin-bottom: `, `px;
`])), U[4], U[6]), Ai = ["children", "darkMode", "className"], He = ba(function(e, o) {
  var t = e.children, l = e.darkMode, s = e.className, d = Ei(e, Ai), b = ya().containerWidth, g = I(l), f = g.darkMode, h = g.theme, p = ga(null), m = ha(t).map(function(N) {
    return _e(N, "DisclaimerText") ? O.createElement("div", { className: Hi, key: "disclaimer-text" }, N) : _e(N, "MessagePrompts") ? O.createElement("div", { key: "message-prompts", className: T(Ti, $e({}, Bi, !!b && b >= Ur.Tablet)) }, N) : N;
  });
  return Ae(function() {
    p.current && p.current.scrollTo(0, p.current.scrollHeight);
  }, [t]), O.createElement(pa, { darkMode: f }, O.createElement("div", Be({}, d, { className: T(Pi, Mi[h], s), ref: o }), O.createElement("div", { className: T(Fi[h], Di), ref: p }, m)));
});
He.displayName = "MessageFeed", He.propTypes = { darkMode: q.bool };
const Ii = ma(async () => ({
  default: (await import("./Message.js")).Message
})), _r = {
  disclaimer_text: Ze`
    text-align: center;
    margin-top: 16px;
    margin-bottom: 32px;
  `,
  message_feed: Ze`
    height: 100%;
    max-height: 70vh;
    & > div {
      box-sizing: border-box;
      max-height: 70vh;
    }
  `
};
function tl(e) {
  const { darkMode: o } = I(e.darkMode), { className: t, disclaimer: l, disclaimerHeading: s, initialMessage: d } = e, { awaitingReply: b, canSubmit: g, conversation: f, handleSubmit: h } = va(), p = d ? [d, ...f.messages] : f.messages;
  return p.length === 0 ? null : /* @__PURE__ */ Ee.jsxs(
    He,
    {
      darkMode: o,
      className: fa(_r.message_feed, t),
      children: [
        l ? /* @__PURE__ */ Ee.jsx(
          da,
          {
            title: s ?? "Terms of Use",
            className: _r.disclaimer_text,
            children: l
          }
        ) : null,
        p.map((m, N) => {
          var D, R, G;
          const L = f.isStreamingMessage ? m.id === ((D = f.streamingMessage) == null ? void 0 : D.id) && ((R = f.streamingMessage) == null ? void 0 : R.content) === "" : !1, M = N === 0;
          return /* @__PURE__ */ Ee.jsx(
            Ii,
            {
              messageData: m,
              isLoading: L,
              showRating: (
                // Users can rate assistant messages that have started streaming
                m.role === "assistant" && !L && !(b && ((G = f.streamingMessage) == null ? void 0 : G.id) === m.id) && // We don't want users to rate the initial message (and they can't because it's not in the database)
                !M
              ),
              conversation: f,
              suggestedPrompts: m.suggestedPrompts,
              showSuggestedPrompts: (
                // For now we'll only show suggested prompts for the initial message and hide them once the user submits anything
                M && f.messages.length === 0
              ),
              onSuggestedPromptClick: h,
              canSubmitSuggestedPrompt: g
            },
            m.id
          );
        })
      ]
    }
  );
}
export {
  tl as ChatMessageFeed
};
